import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'TEXTJOIN',
  category: FunctionCategory.TEXT,
  description:
    'Combines strings across each row of the given columns, separated by a delimiter. Single strings are treated as columns containing only that string.',
  shortDescription: 'Combines strings with a delimiter',
  params: [
    {
      name: 'delimiter',
      type: ArgType.text,
      description:
        'Either a column or string to be used as the delimiter. If empty, text will simply be concatenated.',
    },
    {
      name: 'value',
      type: ArgType.text,
      description: 'Either a column or string.',
    },
  ],
  repeatableLastParamType: ArgType.text,
  repeatableLastParamDescription: 'Additional columns or strings.',
} satisfies AnalysisFunction;
